import { Record, List } from 'immutable';
import { Utils } from '@kineticdata/bundle-common';
const { withPayload } = Utils;
const ns = Utils.namespaceBuilder('survey/app');

export const types = {
  FETCH_APP_DATA_REQUEST: ns('FETCH_APP_DATA_REQUEST'),
  FETCH_APP_DATA_SUCCESS: ns('FETCH_APP_DATA_SUCCESS'),
  FETCH_APP_DATA_FAILURE: ns('FETCH_APP_DATA_FAILURE'),
  FETCH_APP_DATA_REQUIRED: ns('FETCH_APP_DATA_REQUIRED'),
};

export const actions = {
  fetchAppDataRequest: withPayload(types.FETCH_APP_DATA_REQUEST),
  fetchAppDataSuccess: withPayload(types.FETCH_APP_DATA_SUCCESS),
  fetchAppDataFailure: withPayload(types.FETCH_APP_DATA_FAILURE),
  fetchAppDataRequired: withPayload(types.FETCH_APP_DATA_REQUIRED),
};

export const State = Record({
  loading: true,
  error: null,
  forms: null,
  surveys: null,
  templates: null,
  formActions: null,
  required: null,
});

const surveyAppReducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_APP_DATA_REQUEST:
      return state.set('error', null).set('loading', true);
    case types.FETCH_APP_DATA_SUCCESS:
      return state
        .set('forms', List(payload.forms))
        .set('surveys', List(payload.surveys))
        .set('templates', List(payload.templates))
        .set('formActions', List(payload.formActions))
        .set('loading', false);
    case types.FETCH_APP_DATA_FAILURE:
      return state.set('error', payload);
    case types.FETCH_APP_DATA_REQUIRED:
      return state.set('required', payload);
    default:
      return state;
  }
};

export default surveyAppReducer;
